export default "__VITE_ASSET__CicrxQRr__"